import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableAggregated = _resolveComponent("TableAggregated")!

  return (_openBlock(), _createBlock(_component_TableAggregated, {
    class: "analytics-notes-foreign-trade-table",
    "data-pdf-repeat-leading-cols": "1",
    storePaths: _ctx.storePaths,
    generateColumns: _ctx.generateColumns,
    filterParams: _ctx.filter
  }, null, 8, ["storePaths", "generateColumns", "filterParams"]))
}